import { IMoney } from '../../types/IMoney';
import { AccountingChange, AccountingType } from '@lib/accounting/types';
import { ICustomAccounting } from './IInvoiceDraftDto';
import { CreateInvoiceCharge } from './StandaloneInvoiceDraft';
import { InvoiceCreationType } from './InvoiceCreationType';

export interface IQuantityDto {
    amount: number;
    unit: string;
}

export interface IDeliveryRelationDto {
    deliveryReceiptId: number;
    deliveryItemPosition: number;
    deliveryReceiptNumber: string;
}

export interface IOrderRelationDto {
    orderId: string;
    orderItemId: number;
}

export interface ICreateInvoiceItemCommandDto {
    name: string;
    description: string;
    supplierArticleNumber: string;
    quantity: IQuantityDto;
    price: IMoney;
    contentUnitsPerOrderUnit: number;
    contentUnit: string;
    discountPercentage: number;
    taxInPercent: number;
    priceQuantity: number;
    materialGroupCode?: string;
    deliveryRelation?: IDeliveryRelationDto;
    orderRelation?: IOrderRelationDto;
    changeAccountingData: IUpdateAccountingRequestDto[];
}

export interface IUpdateAccountingRequestDto {
    type: AccountingType;
    customAccountingTypeId?: number;
    _value: ICustomAccounting;
}

export class UpdateAccountingRequestDto implements IUpdateAccountingRequestDto {
    _value: ICustomAccounting;
    customAccountingTypeId: number;
    type: AccountingType;

    constructor(event: AccountingChange) {
        this._value = {
            id: event.accountAssignmentId.toString(),
            key: event.accountAssignmentKey,
            name: event.accountAssignmentName,
            description: event.accountAssignmentName,
        };
        this.customAccountingTypeId = event.customAccountingTypeId ?? null;
        this.type = event.type;
    }
}

export interface ICreateInvoiceCommandDto {
    invoiceNumber: string;
    creationType?: InvoiceCreationType;
    remark: string;
    companyCodeId?: string | null;
    sectionId: string;
    supplierCompanyId: string;
    invoiceDate?: string; // ISO DateTime string
    paymentDate?: string; // ISO Date string
    invoiceAddressId: number;
    paymentUntil?: string; // ISO Date string
    comment: string;
    items: ICreateInvoiceItemCommandDto[];
    charges: CreateInvoiceCharge[];
}
